export const rootPaths = {
  root: '/',
  errorsRoot: 'errors',
  userRoot: 'user',
  performanceRoot: 'performance',
  brandingRoot: 'branding',
  brandformanceRoot: 'brandformance',
  managementRoot: 'management',
  adminRoot: 'admin',
  budgetRoot: 'budget',
  reportsRoot: 'reports',
  clientsRoot: 'clients', // Nueva root para clients
  tenantsRoot: 'tenants'
};

const paths = {
  // Dashboard
  dashboard: '/dashboard',
  campaignDashboard: '/campaign-dashboard',
  campaignDashboardWithClient: '/campaign-dashboard/:clientId',
  
  // Claro Dashboard
  claroDashboard: '/claro/dashboard',
  claroMetrics: '/claro/metricas',
  claroJit: '/claro/jit',
  claroJitDashboard: '/claro/jit/dashboard',
  claroWhatsapp: '/claro/whatsapp',
  claroWhatsappDashboard: '/claro/whatsapp/dashboard',
  
  // Dashboard Digital & ATL (all clients)
  dashboardDigital: '/dashboard/digital',
  dashboardATL: '/dashboard/atl',
  mercadoPublicitario: '/dashboard/mercado-publicitario',
  seguimientoCandidatos: '/dashboard/candidatos',
  atlProyecciones: '/dashboard/atl/proyecciones',

  // Ford Sales Dashboard
  fordSales: '/ford/ventas',
  fordSalesDashboard: '/ford/ventas/dashboard',
  fordResultados: '/ford/resultados',
  fordReportes: '/ford/reportes',
  
  // Error pages
  error404: `/${rootPaths.errorsRoot}/404`,

  // User routes
  userProfile: `/${rootPaths.userRoot}/profile`,
  userSettings: `/${rootPaths.userRoot}/settings`,

  // Infomedia routes
  infomedia: '/infomedia',
  infomediaDashboard: '/infomedia/dashboard',
  infomediaMapping: '/infomedia/mapping',
  infomediaUnmapped: '/infomedia/unmapped',
  infomediaData: '/infomedia/data',
  infomediaReports: '/infomedia/reports',
  infomediaSettings: '/infomedia/settings',
  infomediaCompetencia: '/infomedia/competencia',

  // Client routes
  clientsDashboard: `/${rootPaths.clientsRoot}/dashboard`,
  clientsReports: `/${rootPaths.clientsRoot}/reports`,
  clientsDirectory: `/${rootPaths.clientsRoot}/directory`,
  clientsPerformance: `/${rootPaths.clientsRoot}/performance`,
  clientsBudgets: `/${rootPaths.clientsRoot}/budgets`,

  // Admin routes
  users: '/users',
  adminUsers: `/${rootPaths.adminRoot}/users`,
  adminRoles: `/${rootPaths.adminRoot}/roles`,
  adminAudit: `/${rootPaths.adminRoot}/audit`,
  adminFeeConfigurations: `/${rootPaths.adminRoot}/fee-configurations`,
  adminChatConfig: `/${rootPaths.adminRoot}/chat-config`,
  adminClientAssignments: `/${rootPaths.adminRoot}/client-assignments`,
  businessAreas: '/business-areas',
  adminBusinessAreas: `/${rootPaths.adminRoot}/business-areas`,
  settings: '/settings',
  adminSettings: `/${rootPaths.adminRoot}/settings`,

  // Budget routes
  budget: '/budget',
  budgetList: '/budget/list',
  budgetCreate: '/budget/create',
  budgetApprove: '/budget/approve',
  budgetAccounts: '/budget/accounts',

  // Team routes
  team: '/team',

  // Global Accounts Management
  accountsManagement: '/accounts-management',

  // Reports routes
  reports: '/reports',
  reportsDashboard: '/reports/dashboard',
  reportsFinancial: '/reports/financial',
  reportsExport: '/reports/export',

  // Performance routes
  performanceDashboard: `/${rootPaths.performanceRoot}/dashboard`,
  performanceMetrics: `/${rootPaths.performanceRoot}/metrics`,
  performanceObjectives: `/${rootPaths.performanceRoot}/objectives`,
  performanceReports: `/${rootPaths.performanceRoot}/reports`,
  performanceAnalytics: `/${rootPaths.performanceRoot}/analytics`,
  performanceOrderInsert: `/${rootPaths.performanceRoot}/insert-order`,
  performanceAccounts: `/${rootPaths.performanceRoot}/accounts`,
  performanceAccountsManagement: `/${rootPaths.performanceRoot}/accounts-management`,
  performanceAccount: `/${rootPaths.performanceRoot}/account/:accountId`,

  // Branding routes (Control de Presupuestos Branding)
  brandingDashboard: `/${rootPaths.brandingRoot}/dashboard`,
  brandingBudgetControl: `/${rootPaths.brandingRoot}/budget-control`,
  brandingMetrics: `/${rootPaths.brandingRoot}/metrics`, 
  brandingOrderInsert: `/${rootPaths.brandingRoot}/insert-order`,
  brandingAccounts: `/${rootPaths.brandingRoot}/accounts`,
  brandingAccountsManagement: `/${rootPaths.brandingRoot}/accounts-management`,
  brandingReports: `/${rootPaths.brandingRoot}/reports`,
  brandingAnalytics: `/${rootPaths.brandingRoot}/analytics`,
  brandingObjectives: `/${rootPaths.brandingRoot}/objectives`,

  // Brandformance routes (Analytics avanzados)
  brandformanceCampaigns: `/${rootPaths.brandformanceRoot}/campaigns`,
  brandformanceBrands: `/${rootPaths.brandformanceRoot}/brands`,
  brandformanceROI: `/${rootPaths.brandformanceRoot}/roi`,

  // Management routes
  managementTeam: `/${rootPaths.managementRoot}/team`,
  managementKPIs: `/${rootPaths.managementRoot}/kpis`,

  // Chat routes
  chat: '/chat',

  // Data Factory routes
  dataFactory: '/datafactory',

  // Tenants routes (Super Admin only)
  tenantsCompanies: `/${rootPaths.tenantsRoot}/companies`,
  tenantsGlobalConfig: `/${rootPaths.tenantsRoot}/global-config`,
  tenantsMonitoring: `/${rootPaths.tenantsRoot}/monitoring`,
  tenantsLicenses: `/${rootPaths.tenantsRoot}/licenses`
};

export default paths;

